export default {
  GroupActivityTrackerApplyToAll: {
    mounted() {
      this.el.addEventListener("click", () => {
        const fieldName = this.el.getAttribute("data-field-name");
        const contactHcpgID = this.el.getAttribute("data-contact-hcpg-id");

        // Get value set for this button's related input
        const fieldInput = document.getElementById(
          `${contactHcpgID}_${fieldName}`,
        );

        // Find all input elements for this metric field
        const otherInputs = document.querySelectorAll(
          `.metric-field-input-${fieldName}`,
        );

        // Set value on all found inputs
        for (let i = 0; i < otherInputs.length; i += 1) {
          const contactID = otherInputs[i].getAttribute("data-contact-hcpg-id");

          // Is the contact selected?
          const contactCheckbox = document.getElementById(
            `select-contact-checkbox-${contactID}`,
          );

          // Only set metric field on Contacts that are currently selected
          if (contactCheckbox.checked) {
            const otherInput = otherInputs[i].querySelectorAll(
              `[id$='_${fieldName}']`,
            )[0];

            if (otherInput.type === "checkbox") {
              otherInput.checked = fieldInput.checked;
            } else {
              otherInput.value = fieldInput.value;
            }
          }
        }

        // Fire change event so form values are preserved
        fieldInput.dispatchEvent(new Event("input", { bubbles: true }));
      });
    },
  },
};
